import { baseUrl } from "../../../config.js";
import { setDocTitle } from "../../../functions/HelperFuncs.js";

export default {
  data() {
    return {
      user: this.$store.state.user,
      role: this.$store.state.role,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      loading: false,
      details: {
        /* plan: "Merino",
        next_plan: "strong test",
        period: "02/07/20 - 02/08/20",
        billing: {
          interval: "30 days",
          price_unit: "$",
          price: 50,
          interval_abrrv: "mo",
          next_payment: "20/20/2222",
        },*/
      },
      invoices: [
        /*{
          date: "20/5252020",
          plan: "plan test",
          period: "month",
          amount: "50$",
          status: "nice",
        },*/
      ],
      showFeedback: false,
      feedbackType: "success",
      feedback: "",
      isPlanOpen: false,
      features: [
        {
          name: "Storage space",
          icon: "space",
        },
        {
          name: "User Roles",
          icon: "users",
        },
        {
          name: "Quick Transfer",
          icon: "transfer",
        },
        {
          name: `"My Space"`,
          icon: "account",
        },
        {
          name: "Cropping Tool & Presets",
          icon: "crop",
        },
        {
          name: "Face & Object Recognition",
          icon: "info--outline",
        },
        {
          name: "Password Protected Spaces",
          icon: "lock",
        },
      ],
      plans: [
        {
          name: "Suffolk",
          price: "€49.99",
          billingDate: "mo.",
          features: ["100 GB", "2", "2GB", true, true, true, true],
        },
        {
          name: "Merino",
          price: "€69.99",
          billingDate: "mo.",
          features: ["250 GB", "5", "3GB", true, true, true, true],
        },
        {
          name: "Lincoln",
          price: "€99.99",
          billingDate: "mo.",
          features: ["500 GB", "Unlimited", "4GB", true, true, true, true],
        },
      ],
    };
  },
  created() {
    setDocTitle("Billing", this);
    this.$axios
      .get(`${baseUrl}/subscription/details`, {
        responseType: "json",
      })
      .then((response) => {
        this.details = response.data;
      });

    this.$axios
      .get(`${baseUrl}/subscription/invoices`, {
        responseType: "json",
      })
      .then((response) => {
        this.invoices = response.data;
      });

    let self = this;
    setTimeout(function () {
      self.loading = false;
    }, 1000);

    this.processFeedback();
  },
  methods: {
    setFeatureContent(val) {
      return typeof val === "string";
    },
    togglePlans(val, e) {
      e.preventDefault();

      this.isPlanOpen = val;
    },
    getUsedPercentage() {
      // convert to MB
      let usedMb = this.company_full.usage * 1048576; // bytes to mb
      let totalMb = this.company_full.plan.size * 1048576; // bytes to mb

      return (usedMb / totalMb) * 100;
    },
    goTo(route) {
      this.$router.push(route);
      this.show = false;
    },
    goToLink(url) {
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.click();
    },
    processFeedback() {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("status")) {
        switch (urlParams.get("status")) {
          case "open":
            this.feedback = "Your payment is still open. Please complete it";
            this.feedbackType = "error";
            break;
          case "pending":
            this.feedback =
              "Your payment is still pending. You will receive an email once it completed";
            this.feedbackType = "success";
            break;
          case "canceled":
            this.feedback = "Your payment was canceled";
            this.feedbackType = "error";
            break;
          case "expired":
            this.feedback = "Your payment expired. Please start againg";
            this.feedbackType = "error";
            break;
          case "paid":
            this.feedback = "Your payment was successful";
            this.feedbackType = "success";
            break;
          case "failed":
            this.feedback = "Your payment failed";
            this.feedbackType = "error";
            break;
          case "next_cycle":
            this.feedback =
              "Your downgrade is successful. It will be applied on the next invoice";
            this.feedbackType = "success";
            break;
          case "now":
            this.feedback = "Your upgrade is successful!";
            this.feedbackType = "success";
            break;
        }
        if (this.feedback !== "") {
          this.showFeedback = true;
        }
      }
    },
    changePaymentMethod(event) {
      event.preventDefault();
      this.$axios
        .put(baseUrl + "/subscription/change-payment-method")
        .then((response) => {
          if (response.data.message == "Redirect") {
            window.location = response.data.url;
          }
        })
        .catch((response) => {
          console.error("Error");
        });
    },
    getUsedPercentage() {
      // convert to MB
      const usedMb = this.$store.state.company_full.usage * 1048576; // bytes to mb
      const totalMb = this.$store.state.company_full.plan.size * 1048576; // bytes to mb
      const amount = (usedMb / totalMb) * 100;
      return amount < 1 ? 1 : amount;
    },
  },
};
